import { Box, Button, DialogActions, Typography } from "@mui/material";
import { useEffect } from "react";
import { isTablet } from "react-device-detect";

interface MessageAcceptProps {
  onDeleteClick: any;
  onBlockClick: any;
  onAcceptClick: any;
  updateFooterHeight: any;
}

const MessageAccept = ({ onDeleteClick, onBlockClick, onAcceptClick, updateFooterHeight }: MessageAcceptProps) => {
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      const mac: any = document.getElementsByClassName("messageAcceptContainer")[0];
      if (mac) {
        updateFooterHeight(mac.offsetHeight);
      }
    });
    if (document.getElementsByClassName("messageAcceptContainer")[0]) {
      const config: any = { attributes: true, childList: true, characterData: true };
      resizeObserver.observe(document.getElementsByClassName("messageAcceptContainer")[0], config);
    }
    return () => resizeObserver.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box className="messageAcceptContainer w-per-100 bg-true-white mdc-typography--border-top flex-direction-column display-flex-center mar-t-8">
      <Typography className={`text-primary clamp-1 ${isTablet ? "ft-18" : "ft-16"}`} variant={`${isTablet ? "h6" : "subtitle2"}`}>
        Accept message request?
      </Typography>
      <Box className="messageAcceptText">
        <Typography className="text-secondary text-align-c" variant={`${isTablet ? "body1" : "body2"}`}>
          Accepting this request will allow you to send and receive messages directly with this user.
        </Typography>
      </Box>
      <DialogActions className="messageAcceptBtnContainer" sx={{ padding: 0 }}>
        <Button variant="outlined" className="small-btn MuiButtonBase-cancel" onClick={onBlockClick}>
          Block
        </Button>
        <Button variant="outlined" className="small-btn MuiButtonBase-cancel" onClick={onDeleteClick}>
          Delete
        </Button>
        <Button variant="contained" className="small-btn" onClick={onAcceptClick}>
          Accept
        </Button>
      </DialogActions>
    </Box>
  );
};

export default MessageAccept;
